<script setup>
import { computed, ref, toRefs, onMounted, onBeforeUnmount } from "vue";
import $ from 'jquery';

import { __ } from 'JIX/gettext.js';

import SvgIcon from 'JIX/components/SvgIcon.vue';

import 'icons/button-check.svg';
import 'icons/button-arrow-down.svg';

const props = defineProps({
    id: {
        type: String,
        required: true,
    },
    label: {
        type: String,
        required: false,
        default: () => __('Sorter efter:'),
    },
    criteria: {
        type: Array,
        required: true,
    },
    primary: {
        type: String,
        required: true,
    },
    secondary: {
        type: String,
        required: false,
        default: null,
    },
});
const emit = defineEmits(['update:primary', 'update:secondary']);

const { criteria, primary, id } = toRefs(props);

const labelId = computed(() => `${id.value}-label`);
const buttonId = computed(() => `${id.value}-btn`);

const primaryObj = computed(() => criteria.value.find(x => x.key === primary.value));
const secondaryOptions = computed(() => primaryObj.value?.sub || []);

function updatePrimary(item) {
    emit('update:primary', item.key);
    if (item.key !== primaryObj.value.key) {
        if (item.sub && item.sub.length > 0) {
            emit('update:secondary', item.sub[0].key);
        } else {
            emit('update:secondary', null);
        }
    }
}

const button = ref(null);
onMounted(() => {
    $(button.value).dropdown();
});
onBeforeUnmount(() => {
    $(button.value).dropdown('dispose');
});
</script>

<template>
    <div class="jix-sort-by">
        <span class="jix-sort-by__label" :id="labelId">{{ label }}</span>
        <button
            class="jix-sort-by__btn"
            :id="buttonId"
            ref="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            :aria-describedby="labelId"
        >
            {{ primaryObj.label }}
            <SvgIcon name="button-arrow-down" size="micro" role="presentation" />
        </button>
        <div class="dropdown-menu dropdown-menu-right" :aria-labelledby="labelId">
            <button
                @click="updatePrimary(item)"
                v-for="item in criteria"
                :key="item.key"
                :class="['dropdown-item', 'jix-sort-by__item', { 'jix-sort-by__item--selected': item.key === primary } ]"
            >
                <SvgIcon
                    name="button-check"
                    size="micro"
                    role="presentation"
                    class="jix-sort-by__checked-icon"
                    v-if="primary === item.key"
                /><span class="jix-sort-by__item-label">{{ item.label }}</span>
            </button>
            <div class="dropdown-divider" v-if="secondaryOptions.length > 0" />
            <button
                @click="$emit('update:secondary', item.key)"
                v-for="item in secondaryOptions"
                :key="item.key"
                :class="['dropdown-item', 'jix-sort-by__item', { 'jix-sort-by__item--selected': item.key === secondary } ]"
            >
                <SvgIcon
                    name="button-check"
                    size="micro"
                    role="presentation"
                    class="jix-sort-by__checked-icon"
                    v-if="secondary === item.key"
                /><span class="jix-sort-by__item-label">{{ item.label }}</span>
            </button>
        </div>
    </div>
</template>
